import { useState, useRef, useEffect } from "react";
import axios from "axios";
import QRCodeStyling from "qr-code-styling";

export default function QRForm() {
  const [form, setForm] = useState({});
  const [qrUrl, setQrUrl] = useState("");
  const [logo, setLogo] = useState(null);
  const qrRef = useRef(null);
  const qrCode = useRef(null);

  // 🔹 INIT QR (empty first, will update when qrUrl is set)
  useEffect(() => {
    qrCode.current = new QRCodeStyling({
      width: 220,
      height: 220,
      data: "",
      image: "",
      dotsOptions: { color: "#2d4ea2", type: "rounded" },
      cornersSquareOptions: { type: "extra-rounded", color: "#2d4ea2" },
      cornersDotOptions: { type: "dot", color: "#2d4ea2" },
      backgroundOptions: { color: "#ffffff" },
      imageOptions: { crossOrigin: "anonymous", margin: 5 }
    });
  }, []);

  // 🔹 UPDATE QR when qrUrl or logo changes
  useEffect(() => {
    if (!qrCode.current || !qrUrl) return;
    qrCode.current.update({ data: qrUrl, image: logo || "" });
    qrCode.current.append(qrRef.current);
  }, [qrUrl, logo]);

  const saveQR = async () => {
    try {
      const res = await axios.post(
        "https://mdqapps.online/qrgen_api/api/save_qr.php",
        form
      );
      const id = res.data.id;
      const url = `https://mdqapps.online/qrgen_api/api/contact.php?id=${id}`;
      setQrUrl(url);
      alert("Saved & QR Generated!");
    } catch (err) {
      console.error(err);
      alert("Error saving data");
    }
  };

  const downloadQR = () => {
    if (qrCode.current) qrCode.current.download({ name: "qr", extension: "png" });
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h2 style={styles.title}>QR Contact Generator</h2>

        {/* FORM */}
        <div style={styles.formGrid}>
          {["name","company","title","phone","phone2","email","website","address"].map((field) => (
            <input
              key={field}
              style={styles.input}
              placeholder={field.charAt(0).toUpperCase() + field.slice(1)}
              onChange={(e) => setForm({ ...form, [field]: e.target.value })}
            />
          ))}

          {/* LOGO UPLOAD */}
          <input
            type="file"
            accept="image/*"
            style={styles.input}
            onChange={(e) => {
              const file = e.target.files[0];
              if (file) {
                const reader = new FileReader();
                reader.onload = () => setLogo(reader.result);
                reader.readAsDataURL(file);
              }
            }}
          />
        </div>

        {/* PREVIEW LOGO */}
        {!qrUrl && logo && (
          <img src={logo} alt="logo" style={{ width: 50, marginTop: 10 }} />
        )}

        {/* QR DISPLAY */}
        {qrUrl && (
          <div style={styles.qrBox}>
            <div ref={qrRef} style={{ width: 220, height: 220 }} />
          </div>
        )}

        {/* BUTTONS */}
        <div style={styles.btnGroup}>
          <button style={styles.saveBtn} onClick={saveQR}>Save & Generate QR</button>
          {qrUrl && <button style={styles.downloadBtn} onClick={downloadQR}>Download QR</button>}
        </div>
      </div>
    </div>
  );
}

const styles = {
  container: {
    minHeight: "100vh",
    background: "linear-gradient(135deg, #0f172a, #1e3a8a)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontFamily: "Arial"
  },
  card: {
    background: "#0b1120",
    padding: "30px",
    borderRadius: "12px",
    width: "350px",
    boxShadow: "0 10px 30px rgba(0,0,0,0.5)",
    textAlign: "center",
    color: "#fff"
  },
  title: { marginBottom: "20px", color: "#60a5fa" },
  formGrid: { display: "flex", flexDirection: "column", gap: "10px" },
  input: { padding: "10px", borderRadius: "6px", border: "1px solid #1e40af", background: "#020617", color: "#fff", outline: "none" },
  qrBox: { marginTop: "20px", padding: "15px", background: "#fff", borderRadius: "12px", display: "inline-block" },
  btnGroup: { marginTop: "20px", display: "flex", justifyContent: "space-between", gap: "10px" },
  downloadBtn: { background: "#2563eb", color: "#fff", border: "none", padding: "10px 15px", borderRadius: "6px", cursor: "pointer" },
  saveBtn: { background: "#16a34a", color: "#fff", border: "none", padding: "10px 15px", borderRadius: "6px", cursor: "pointer" }
};